import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonServiceService } from '../services/common-service.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss'],
})
export class AboutUsComponent implements OnInit {
  aboutUS: any;

  constructor(private commonService: CommonServiceService, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.getAboutUsPageData();
  }

  getAboutUsPageData(): void {
    this.commonService.aboutUsData().subscribe((res: any) => {
      this.aboutUS = res?.data;
    });
  }
  stripHtmlTags(input: any): string {
    const doc: any = new DOMParser().parseFromString(input, 'text/html');
    const images = doc.querySelectorAll('img');

    const textContent = doc.body.textContent || '';

    images.forEach((image: any) => {
      image.classList.add('img-fluid');
    });
    return doc.body.innerHTML;
  }
  showInnerHTMLData(data: string): string {
    let trustedHtml = '';
    trustedHtml = this.sanitizer.bypassSecurityTrustHtml(data) as string;
    return trustedHtml;
  }
}
